import { useLocation } from 'react-router-dom';

const useIsLenderView = () => {
  const location = useLocation();
  return location.pathname === '/lend' || location.pathname.includes(`/lend/`);
};

export default useIsLenderView;
